import React from 'react';
import { Card, Icon, Popup } from 'semantic-ui-react';

const IconCard = ({
  iconClass, title, subtitle, iconName, description
}) => (
  <Card className="icon-card-container">
    <Card.Content>
      <div className="header">
        <div className={`circle icon-card-${iconClass}`}>
          <Icon as="i" name={iconName} />
        </div>
      </div>
      <div className="description">
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
      </div>
      <Popup
        content={description}
        key={title}
        trigger={<Icon className="infoIcon" style={{ position: 'absolute', right: 5, top: 5 }} as="i" name="info circle" />}
        basic
        wide="very"
        position="top center"
      />
    </Card.Content>
  </Card>
);

export default IconCard;
